import { Link } from "@tanstack/react-router";

import { Logo } from "../../ui/Logo";
import classes from "./shell.module.css";

/** The wordmark, linking to the team's home (or to `/`, which opens the first team). */
export function LogoLink({ teamId }: { teamId: string | undefined }) {
  return teamId === undefined ? (
    <Link to="/" className={classes.logo} aria-label="Created.ai home">
      <Logo />
    </Link>
  ) : (
    <Link
      to="/teams/$teamId"
      params={{ teamId }}
      className={classes.logo}
      aria-label="Created.ai home"
    >
      <Logo />
    </Link>
  );
}
